export default __webpack_public_path__ + "static/TrustAlice Icon-f52bd3e6e72a84ab1b362bdf74fa6059.svg";